import { COLORS } from 'helpers/globals'

export default {
  permalink: {
    '&::selection': { color: COLORS.primary }
  },
  copyButton: {
    display: 'block',
    margin: '1rem auto 0 auto',
    fontSize: '1.6rem',
    borderRadius: '1rem',
    '@media screen and (min-width: 801px)': {
      display: 'inline-block',
      margin: '0 0 0 1rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Permalink/style.js